import {useEffect, useState} from "react";
import {DateTime} from "luxon";
import {Periodo} from "@commons/types";

/**
 * Funzione per il calcolo del numero delle settimane che compongono un periodo (anno/mese)
 * Viene banalmente scorso tutto il mese tenendo traccia di quante volte cambia il numero della settimana;
 * in questo modo si evitano tutti i problemi legati al numero delle settimane a cavallo di anno|
 * @param periodo
 */
const calcola = (periodo: Periodo) => {
    const {anno, mese} = periodo;
    const inizioMese = DateTime.local(anno, mese, 1).startOf('day');
    const fineMese = DateTime.local(anno, mese, 1).endOf('month').startOf('day');
    let numWeek = 1;
    let lastWeek = inizioMese.weekNumber;
    for (let dt = inizioMese; dt < fineMese; dt = dt.plus({days: 1})) {
        if (dt.weekNumber !== lastWeek) {
            ++numWeek;
            lastWeek = dt.weekNumber;
        }
    }
    //console.log('numWeek', numWeek);
    return {numWeek}
}

/**
 * hook che restituisce il numero di settimane di <periodo>, opportunamente aggiornato al variare di <periodo> stesso!
 * @param periodo
 */
export const useWeekPeriodo = (periodo: Periodo) => {

    const [numWeek, setNumWeek] = useState<number>(calcola(periodo).numWeek);
    useEffect(() => {
        const r = calcola(periodo);
        //console.log('numWeek', r.numWeek);
        setNumWeek(r.numWeek);
    }, [periodo, setNumWeek]);
    return [numWeek];
}